angular.module("vgresiduos").controller("FeatureToggleListCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/feature-toggles`);
		};
	}
]);
